import { memo } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useOrganizationStore } from "stores/OrganizationStore";

// -----------------------------------------------------------------------------

const EnvironmentPossibleSource = memo(function EnvironmentPossibleSource({
  source: { label, coverImage: CoverImage, onConnect } = {} as any,
  hideDismissButton,
}: EnvironmentPossibleSourceProps): JSX.Element {
  const [organizationStore] = useOrganizationStore();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  //
  return (
    <Grid item xs={12} sm={6} md={6} lg={3}>
      <Card elevation={1} sx={{ maxHeight: 192, position: "relative" }}>
        <Box
          sx={{
            paddingTop: `${100 * (10 / 16)}%`,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              bottom: 0,
              left: 0,
              position: "absolute",
              top: 0,
              right: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                flexGrow: 1,
                padding: "16px 32px",
              }}
            >
              <CoverImage
                alt={label}
                sx={{
                  flexGrow: 1,
                  width: "100%",
                }}
              />
            </Box>
            <Stack
              direction="row"
              sx={{
                borderTop: "1px rgba(0, 0, 0, 0.1) solid",
                flexShrink: 0,
                p: 1,
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              {hideDismissButton ? null : <Button>Dismiss</Button>}
              {!isMobile && <Box sx={{ flexGrow: 1 }} />}
              <Button
                variant="contained"
                onClick={() => onConnect?.(organizationStore, navigate)}
                sx={{
                  flexGrow: isMobile ? 1 : 0,
                }}
              >
                Connect
              </Button>
            </Stack>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
});

export default EnvironmentPossibleSource;

// -----------------------------------------------------------------------------

interface EnvironmentPossibleSourceProps {
  source: {
    name: string;
    label: string;
    coverImage: Function;
    onConnect: Function;
  };

  hideDismissButton?: boolean;
}
